export function invertPlanName(listNamePlansToShow) {
    const namesInverted = {};

    for (const [key, values] of Object.entries(listNamePlansToShow.current)) {
      values.forEach((value) => {
        namesInverted[value] = key;
      });
    }
    return namesInverted;
}